import useTrackingEventEmitter from './use-tracking-event-emitter'

export default useTrackingEventEmitter
